import workspaceQuery from '../../../graphql/queries/sales/ImportedEtsyOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedEtsyOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedEtsyOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedEtsyOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedEtsyOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedEtsyOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedEtsyOrder: EntityType = {
  type: 'ImportedEtsyOrder',
  title: 'Etsy Orders',
  formTitle: 'Imported Etsy Order',
  workspaceUrl: '/Sales/Channel/ImportedEtsyOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedEtsyOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_ETSY_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedEtsyOrder;
